
module.exports = {

	default: { click: { dest: 'customer', elem: 'page', act: 'show', id: `customer-page`, leftnav: 'leftnav-customer-page', from: 'leftnav' }, },

	//-------------------------------------------------------------------------------------------------------------------------------------
	purchase: {
		mainPage: true,
		activePage: '',
		click: { dest: 'purchase', elem: 'page', act: 'show', id: `purchase-page`, leftnav: 'leftnav-purchase-page', from: 'leftnav' },
	},
	
	purchaseDeleted: {
		mainPage: true,
		activePage: '',
		click: { dest: 'purchaseDeleted', elem: 'page', act: 'show', id: `purchaseDeleted-page`, leftnav: 'leftnav-purchaseDeleted-page', from: 'leftnav' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	sale: {
		mainPage: true,
		activePage: '',
		click: { dest: 'sale', elem: 'page', act: 'show', id: `sale-page`, leftnav: 'leftnav-sale-page', from: 'leftnav' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------

	item: {
		mainPage: true,
		activePage: '',
		click: { dest: 'item', elem: 'page', act: 'show', id: `item-page`, leftnav: 'leftnav-item-page', from: 'leftnav' },
	},

	areas: {
		mainPage: false,
		activePage: '',
		parentPage: 'item',
		click: { dest: 'areas', elem: 'page', act: 'show', id: `areas-page`, leftnav: 'leftnav-item-page', },
	},

	item_unit: {
		mainPage: false,
		parentPage: 'item',
		click: { dest: 'item_unit', elem: 'page', act: 'show', id: `item_unit-page`, leftnav: 'leftnav-item-page', },
	},

	suggestion: {
		mainPage: false,
		parentPage: 'item',
		click: { dest: 'suggestion', elem: 'page', act: 'show', id: `suggestion-page`, leftnav: 'leftnav-item-page' },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	customer: {
		mainPage: true,
		activePage: '',
		click: { dest: 'customer', elem: 'page', act: 'show', id: `customer-page`, leftnav: 'leftnav-customer-page', from: 'leftnav' },
	},

	provider: {
		mainPage: false,
		parentPage: 'customer',
		click: { dest: 'provider', elem: 'page', act: 'show', id: `provider-page`, leftnav: 'leftnav-customer-page', },
	},


	//-------------------------------------------------------------------------------------------------------------------------------------
	transaction: {
		mainPage: true,
		activePage: '',
		click: { dest: 'transaction', elem: 'page', act: 'show', id: `transaction-page`, leftnav: 'leftnav-transaction-page', from: 'leftnav' },
	},

	receivepayment: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'receivepayment', elem: 'page', act: 'show', id: `receivepayment-page`, leftnav: 'leftnav-accounts-page', },
	},
	customercredit: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'customercredit', elem: 'page', act: 'show', id: `customercredit-page`, leftnav: 'leftnav-accounts-page', },
	},



	sentpayment: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'sentpayment', elem: 'page', act: 'show', id: `sentpayment-page`, leftnav: 'leftnav-accounts-page', },
	},

	providercredit: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'providercredit', elem: 'page', act: 'show', id: `providercredit-page`, leftnav: 'leftnav-accounts-page', },
	},


	otherexpense: {
		mainPage: false,
		parentPage: 'transaction',
		click: { dest: 'otherexpense', elem: 'page', act: 'show', id: `otherexpense-page`, leftnav: 'leftnav-accounts-page', },
	},

	//-------------------------------------------------------------------------------------------------------------------------------------
	admin: {
		mainPage: true,
		activePage: '',
		click: { dest: 'admin', elem: 'page', act: 'show', id: `admin-page`, leftnav: '' },
	},
	// dashboard: {
	// 	mainPage:true,
	// 	activePage:'',
	// 	click: {dest: 'dashboard', elem: 'page', act: 'show', id: `dashboard-page`, leftnav: '' }, 
	// }, 

	// // remover 'report' cuando miguel indique
	// report: {
	// 	mainPage:true,
	// 	activePage:'',
	// 	click: {dest: 'report', elem: 'page', act: 'show', id: `report-page`, leftnav: '' }, 
	// }, 
	report: {
		mainPage: true,
		activePage: '',
		click: { dest: 'report', elem: 'page', act: 'show', id: `report-page`, leftnav: '' },
	},

	dashboard: {
		mainPage: true,
		activePage: '',
		click: { dest: 'dashboard', elem: 'page', act: 'show', id: `dashboard-page`, leftnav: 'leftnav-dashboard-page', from: 'leftnav' },
	},

	// reportHub: {
	// 	mainPage: true,
	// 	activePage: '',
	// 	click: { dest: 'reportHub', elem: 'page', act: 'show', id: `reportHub-page`, leftnav: 'leftnav-reportHub-page', from: 'leftnav' },
	// },

	accountsReceivable: {
		mainPage: false,
		parentPage: 'dashboard',
		click: { dest: 'accountsReceivable', elem: 'page', act: 'show', id: `accountsReceivable-page`, leftnav: 'leftnav-dashboard-page' },
	},

	accountsPayable: {
		mainPage: false,
		parentPage: 'dashboard',
		click: { dest: 'accountsPayable', elem: 'page', act: 'show', id: `accountsPayable-page`, leftnav: 'leftnav-dashboard-page' },
	},

	customerProfit: {
		mainPage: false,
		parentPage: 'dashboard',
		click: { dest: 'customerProfit', elem: 'page', act: 'show', id: `customerProfit-page`, leftnav: 'leftnav-dashboard-page' },
	},

	providerProfit: {
		mainPage: false,
		parentPage: 'dashboard',
		click: { dest: 'providerProfit', elem: 'page', act: 'show', id: `providerProfit-page`, leftnav: 'leftnav-dashboard-page' },
	},

	users: {
		mainPage: true,
		activePage: '',
		click: { dest: 'users', elem: 'page', act: 'show', id: `users-page`, leftnav: '' },
	},

	employesspayment: {
		mainPage: true,
		activePage: '',
		click: { dest: 'employesspayment', elem: 'page', act: 'show', id: `employesspayment-page`, leftnav: '' },
	},

	equitydeposit: {
		mainPage: true,
		activePage: '',
		click: { dest: 'equitydeposit', elem: 'page', act: 'show', id: `equitydeposit-page`, leftnav: '' },
	},

	accounts: {
		mainPage: true,
		activePage: '',
		click: { dest: 'accounts', elem: 'page', act: 'show', id: `accounts-page`, leftnav: '' },
	},

}